/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_apex_too_many_selections = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Too many selections — remove some to see teams`)
};

const es_f1_apex_too_many_selections = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demasiadas selecciones — elimina algunas para ver los equipos`)
};

const de_f1_apex_too_many_selections = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zu viele Auswahlen — entferne einige, um Teams zu sehen`)
};

const nl_f1_apex_too_many_selections = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Te veel selecties — verwijder er een paar om teams te zien`)
};

const fr_f1_apex_too_many_selections = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trop de sélections — retirez-en quelques-unes pour voir les équipes`)
};

const it_f1_apex_too_many_selections = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Troppe selezioni — rimuovine alcune per vedere i team`)
};

const pt_br2_f1_apex_too_many_selections = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muitas seleções — remova algumas para ver as equipes`)
};

const pt_f1_apex_too_many_selections = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demasiadas seleções — remova algumas para ver as equipas`)
};

const ja_f1_apex_too_many_selections = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択が多すぎます — いくつか削除してチームを確認`)
};

const zh_f1_apex_too_many_selections = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择太多 — 请删除一些以查看车队`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_apex_too_many_selections = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_apex_too_many_selections(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_apex_too_many_selections", locale)
	if (locale === "en") return en_f1_apex_too_many_selections(inputs)
	if (locale === "es") return es_f1_apex_too_many_selections(inputs)
	if (locale === "de") return de_f1_apex_too_many_selections(inputs)
	if (locale === "nl") return nl_f1_apex_too_many_selections(inputs)
	if (locale === "fr") return fr_f1_apex_too_many_selections(inputs)
	if (locale === "it") return it_f1_apex_too_many_selections(inputs)
	if (locale === "pt-BR") return pt_br2_f1_apex_too_many_selections(inputs)
	if (locale === "pt") return pt_f1_apex_too_many_selections(inputs)
	if (locale === "ja") return ja_f1_apex_too_many_selections(inputs)
	return zh_f1_apex_too_many_selections(inputs)
};